import {
  CustomerOrganization,
  CustomerOrgCompany,
} from "../../../common/types/apiTypes";
import { WorkLocation } from "../../orders/orderTypes";
import { WorkTitle } from "../../orders/orderAPI";
import { TalentBlacklist } from "../../talents/talentAPI";
import {
  AddBlacklistEntry,
  UpdateBlacklistEntry,
} from "../../talents/types/commands";

export type BlacklistFormValues = {
  blockingParty: string;
  customerCompany: CustomerOrgCompany | null;
  customerOrganization: CustomerOrganization | null;
  workLocation: WorkLocation | null;
  workTitles: WorkTitle[];
  reason: string;
};

export const defaultBlacklistFormValues: BlacklistFormValues = {
  blockingParty: "CUSTOMER",
  customerCompany: null,
  customerOrganization: null,
  workLocation: null,
  workTitles: [],
  reason: "",
};

export const mapEntryToBlacklistFormValues = (
  entry: TalentBlacklist,
  localizedWorkTitles: Record<string, string>,
): BlacklistFormValues => ({
  blockingParty: entry.blockingParty ?? "CUSTOMER",
  customerCompany: entry.customerCompanyId
    ? ({ id: entry.customerCompanyId, name: entry.customerCompanyName ?? "" } as CustomerOrgCompany)
    : null,
  customerOrganization:
    entry.customerOrganizationId && entry.customerOrganizationName
      ? ({ id: entry.customerOrganizationId, name: entry.customerOrganizationName } as CustomerOrganization)
      : null,
  workLocation:
    entry.workLocationId && entry.workLocationName
      ? ({ id: entry.workLocationId, name: entry.workLocationName } as WorkLocation)
      : null,
  workTitles: (entry.workTitles ?? []).map((wt) => ({
    ...wt,
    name: localizedWorkTitles[wt.id] ?? wt.id,
  })),
  reason: entry.reason ?? "",
});

export const mapFormToAddBlacklistPayload = (
  formData: BlacklistFormValues,
  talentId: string,
): AddBlacklistEntry => ({
  talentId,
  blockingParty: formData.blockingParty,
  customerCompanyId: formData.customerCompany!.id,
  customerOrganizationId: formData.customerOrganization?.id,
  workLocationId: formData.workLocation?.id,
  workTitleIds: formData.workTitles.map((wt) => wt.id),
  reason: formData.reason,
});

export const mapFormToUpdateBlacklistPayload = (
  formData: BlacklistFormValues,
  entry: TalentBlacklist,
): UpdateBlacklistEntry => ({
  blacklistEntryId: entry.id,
  updatedCustomerOrganizationId: formData.customerOrganization?.id,
  updatedWorkLocationId: formData.workLocation?.id,
  updatedWorkTitleIds: formData.workTitles.map((wt) => wt.id),
  updatedReason: formData.reason,
  version: entry.version,
});
